import { render, staticRenderFns } from "./IgExternalForm.vue?vue&type=template&id=5179deb3&"
import script from "./IgExternalForm.vue?vue&type=script&lang=js&"
export * from "./IgExternalForm.vue?vue&type=script&lang=js&"
import style0 from "./IgExternalForm.vue?vue&type=style&index=0&id=5179deb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports